import { mediaSourceNonempty } from '../mediaAggregates';

// Chaves de array que compõem o dataset carregado do backend (App.js allFetchedData).
export const DATASET_ARRAY_KEYS = [
  'checkins',
  'health',
  'moves',
  'movies',
  'shows',
  'diary',
  'concerts',
  'googleMaps',
  'spotify',
  'appleMusic',
  'photos',
];

/** True quando nenhuma fonte tem registros — first-run / DB vazio. */
export function isDatasetEmpty(data) {
  if (!data || typeof data !== 'object') return true;
  return DATASET_ARRAY_KEYS.every((key) => !mediaSourceNonempty(data[key]));
}
